import { OBSERVACIO_DATA_SELECCIONADA, OBSERVACIO_INICIALITZAR } from '../../actions/actionTypes';

const ESTAT_INICIAL_DATA_SELECCIONADA = '';

const dataSeleccionada = (state = ESTAT_INICIAL_DATA_SELECCIONADA, action) => {
    switch (action.type) {
        case OBSERVACIO_DATA_SELECCIONADA:
            return action.dataSeleccionada;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_DATA_SELECCIONADA;
        default:
            return state;
    }
};

export default dataSeleccionada;



// WEBPACK FOOTER //
// ./src/reducers/observacio/dataSeleccionada.js